module.exports = __webpack_public_path__ + "img/hover-right.6d539573.svg";